import { DatatableColumn } from "../datatable-types";

export const resolveSubSectionColumnIdFromUrl = (
  urlParams: URLSearchParams,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): string | undefined => {
  const subSectionColumnId = urlParams.get("subSectionColumnId");

  if (!subSectionColumnId) {
    return undefined;
  }

  const column = columns.find((column) => column.columnId === subSectionColumnId);

  if (!column) {
    return undefined;
  }

  if (column.enableSectioning) {
    return subSectionColumnId;
  }
};

export const encodeSubSectionColumnIdToUrl = (
  urlParams: URLSearchParams,
  subSectionColumnId: string | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: DatatableColumn<any>[],
): URLSearchParams => {
  const updatedParams = new URLSearchParams(urlParams);

  if (subSectionColumnId) {
    const column = columns.find((column) => column.columnId === subSectionColumnId);

    if (!column || !column.enableSectioning) {
      console.error(`Subsection column ID ${subSectionColumnId} is not valid`);
    } else {
      updatedParams.set("subSectionColumnId", subSectionColumnId);
    }
  } else {
    updatedParams.delete("subSectionColumnId");
  }

  return updatedParams;
};
